// @flow

import config from 'config/app.config';
import { ActionsObservable, combineEpics } from 'redux-observable';
import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { filter, switchMap, map, catchError } from 'rxjs/operators';

import { API } from '../../utils/APIUtils';
import { generateId } from '../../utils/CommonUtils';
import {
  GET_DATALAYER_REQUEST,
  GET_DATALAYER_SUCCESS,
  GET_DATALAYER_ERROR,
  GET_DATALAYER_AJAX_ERROR,
} from '../actions';
import type {
  TagManagerActions,
  GetDataLayerParams,
  GetDataLayerResponse,
  GetDataLayerError,
  MessageRequest,
  MessageResponse,
} from '../types';

const getDataLayerRequestEpic = (action$: ActionsObservable<TagManagerActions>) =>
  action$.pipe(
    filter(action => action.type === GET_DATALAYER_REQUEST),
    switchMap((request) => {
      const json: MessageRequest<GetDataLayerParams> = {
        method: API.GetDataLayer,
        params: request.payload,
        ts: Date.now(),
        ns: config.apiNSTagCommander,
        id: generateId('GetDataLayer'),
      };

      return ajax({
        url: `${config.apiURL}${config.apiNSTagCommander}`,
        type: 'POST',
        method: 'POST',
        body: JSON.stringify(json),
        dataType: 'json',
      }).pipe(
        map((ajaxResponse) => {
          const {
            response,
          }: { response: MessageResponse<GetDataLayerResponse, GetDataLayerError> } = ajaxResponse;

          if (response.error) {
            return {
              type: GET_DATALAYER_ERROR,
              payload: response.error,
            };
          }

          return {
            type: GET_DATALAYER_SUCCESS,
            payload: response,
          };
        }),
        catchError(e => of({ type: GET_DATALAYER_AJAX_ERROR, payload: e })),
      );
    }),
  );

export const tagManagerEpics = combineEpics(getDataLayerRequestEpic);
